/*
Flexible Materials
  --bend <float> | inches | ('Inches of Bend')
  --coreType <string::combobox>
  --insideRadius <float> | inches
  --outsideRadius <float> | inches
  --manufacturer <Manufacturer>
  --manufacturerNumber <string>
  --computerEaseNumber <string>
*/
import { manufacturer } from '@/modules/standardItems/schemas/baseFilters'
import sheetStockFilters from '@/modules/standardItems/schemas/sheetStock/filters'

export default [
  {
    label: 'Name',
    value: 'name',
    type: 'list',
    returnObject: false
  },
  ...sheetStockFilters(),
  {
    label: 'Core Type',
    value: 'coreType',
    type: 'list'
  },
  manufacturer(),
  {
    label: 'Bend',
    value: 'bend',
    type: 'range'
  },
  {
    label: 'Inside Radius',
    value: 'insideRadius',
    type: 'range'
  },
  {
    label: 'Outside Radius',
    value: 'outsideRadius',
    type: 'range'
  }
]
